import { Component, OnInit } from '@angular/core';
import { ListBaseComponent } from 'app/shared/components/base/list-base/list-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Sections } from 'app/shared/constants/sections';
import { AuditLogFilter } from 'app/shared/filters/audit-log.filter';
import { AuditLogDetail } from 'app/shared/models/audit-log-detail.model';
import { AuditLog } from 'app/shared/models/audit-log.model';
import { AuditLogService } from 'app/shared/services/audit-log.service';
import { SectionService } from 'app/shared/services/section.service';

@Component({
  selector: 'app-audit-logs-list',
  templateUrl: './audit-logs-list.component.html',
  styleUrls: ['./audit-logs-list.component.scss']
})
export class AuditLogsListComponent extends ListBaseComponent implements OnInit {

  fieldCollection = [
    {name: 'AuditLogId', displayName: 'auditLogs.auditLogIdFieldTitle', canSort: true, displayClass: ""},
    {name: 'EventDateUTC', displayName: 'auditLogs.eventDateUTCFieldTitle', canSort: true, displayClass: ""},
    {name: 'UserName', displayName: 'auditLogs.userNameFieldTitle', canSort: true, displayClass: ""},
    {name: 'EventType', displayName: 'auditLogs.eventTypeFieldTitle', canSort: true, displayClass: ""},
    {name: 'TypeFullName', displayName: 'auditLogs.typeFullNameFieldTitle', canSort: true, displayClass: ""},
    {name: 'RecordId', displayName: 'auditLogs.recordIdFieldTitle', canSort: true, displayClass: ""},
    {name: 'PropertyName', displayName: 'auditLogs.propertyNameFieldTitle', canSort: false, displayClass: ""},
    {name: 'OriginalValue', displayName: 'auditLogs.originalValueFieldTitle', canSort: false, displayClass: ""},
    {name: 'NewValue', displayName: 'auditLogs.newValueFieldTitle', canSort: false, displayClass: ""}
  ];

  newValue: string;
  auditLogFilter: AuditLogFilter;

  constructor(protected sectionService: SectionService, protected auditLogService: AuditLogService) {
    super(sectionService, Sections.AuditLogs);
  }

  ngOnInit() {
    this.auditLogFilter = new AuditLogFilter();
    super.initializeView(Constants.AuditLogs_List_DefaultSortField, Constants.AuditLogs_List_DefaultSortDirectionAscending);
  }

  onKeydown(event: any) {
    if (event.key === "Enter") {
      this.searchFilter(event.target.value);
    }
  }

  searchFilter(newValue: string) {
    this.auditLogFilter.NewValue = newValue;
    this.getCollection();
  }

  getCollection(pageNumber: number = 1) {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.auditLogService.getCollectionPaginated<AuditLog>("/auditlog", this.pageConfiguration, this.auditLogFilter, (collection) => {
      collection.forEach(auditLog => {
        auditLog.IsCollapsed = true
      });
      this.collection = collection;
    });
  }

  showDetails(auditLog: AuditLog) {
    auditLog.IsCollapsed = !auditLog.IsCollapsed;

    if (!auditLog.IsCollapsed) {
      if (auditLog.AuditLogId) {
        this.auditLogService.getCollection<AuditLogDetail>("/auditlog/details/" + auditLog.AuditLogId, this.auditLogFilter, (collection) => {
          auditLog.AuditLogDetails = collection
        });
      }
    }
  }
}
